import { createElement, forwardRef } from 'react'

import { SubCollectionSectionDS } from '@src/components/blocks/sub-collection-section-ds'
import type { SubCollectionSectionProps } from '@src/components/blocks/sub-collection-section-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import SubCollectionSectionLegacy from './sub-collection-section-legacy'

const SubCollectionSection = forwardRef<HTMLDivElement, SubCollectionSectionProps>((props, ref) => {
  if (shouldUseDesignSystem()) {
    return createElement(SubCollectionSectionDS, { ...props, ref })
  }

  return createElement(SubCollectionSectionLegacy, { ...props, ref })
})

SubCollectionSection.displayName = 'SubCollectionSection'

export default SubCollectionSection
